module.exports = __webpack_public_path__ + "img/52ne.d631167e.svg";